import React, { useEffect, useMemo, useState } from 'react';
import useGetSettingData from 'hooks/useGetSettingData';
import s from './s.module.less';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import {
    ConnectPayments,
    ConnectDocuments,
    ConnectAccountOnboarding,
    ConnectComponentsProvider,
} from '@stripe/react-connect-js';
import { STRIPE_KEY } from 'utils/common';

interface IProps {
    client_secret?: string;
    onExit?: () => void;
}

const StripeOnboardingComponent = ({ client_secret, onExit }: IProps) => {
    const [stripeConnectInstance, setStripeConnectInstance] = useState<any>(null);
    React.useEffect(() => {
        const fetchClientSecret = async () => {
            return client_secret!;
        };
        setStripeConnectInstance(
            loadConnectAndInitialize({
                // This is your test publishable API key.
                publishableKey: STRIPE_KEY,
                fetchClientSecret,
            }),
        );
    }, [client_secret]);
    return (
        <div className={s.wrap}>
            {
                stripeConnectInstance &&
                <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                    <ConnectAccountOnboarding
                        onExit={() => {
                            console.log('The account has exited onboarding');
                            onExit?.();
                        }}
                    // Optional: make sure to follow our policy instructions above
                    // fullTermsOfServiceUrl="{{URL}}"
                    // recipientTermsOfServiceUrl="{{URL}}"
                    // privacyPolicyUrl="{{URL}}"
                    // skipTermsOfServiceCollection={false}
                    // collectionOptions={{
                    //   fields: 'eventually_due',
                    //   futureRequirements: 'include',
                    // }}
                    // onStepChange={(stepChange) => {
                    //     console.log(`User entered: ${stepChange.step}`);
                    // }}
                    />
                </ConnectComponentsProvider>
            }

        </div>
    );
};

export default StripeOnboardingComponent;
